import { mountLegendPanel } from './legend-panel.js';
import { mountOverviewPanel } from './overview-panel.js';
import { mountSourcesPanel } from './sources-panel.js';
import { mountSettingsPanel, unmountSettingsPanel } from './settings-panel.js';

export function closeNewsGraph() {
  document.body.classList.remove('news-graph-active');
  const newsGraphWrapper = document.getElementById('news-graph-wrapper');
  if (newsGraphWrapper) newsGraphWrapper.remove();
  
  const legendPanel = document.getElementById('news-graph-legend-vr');
  if (legendPanel) legendPanel.remove();

  unmountSettingsPanel();
  
  const overviewPanelWrapper = document.getElementById('news-graph-overview-vr-wrapper');
  if (overviewPanelWrapper) overviewPanelWrapper.remove();
  
  const leftOverview = document.getElementById('news-graph-overview-vr-left');
  if (leftOverview) leftOverview.remove();

  const rightOverview = document.getElementById('news-graph-overview-vr-right');
  if (rightOverview) rightOverview.remove();


  const leftPanel2 = document.querySelector('#left-panel-2');
  if (leftPanel2) {
    const s1 = leftPanel2.querySelector('#news-screen-1');
    if (s1) {
      s1.setAttribute('visible', true);
      s1.setAttribute('position', '0 0 0.02');
    }
    
    const sourcesPanel = leftPanel2.querySelector('#news-graph-sources-vr');
    if (sourcesPanel) sourcesPanel.remove();
  }

  const rightPanel = document.querySelector('#right-container');
  if (rightPanel) {
    const rightOverview = rightPanel.querySelector('#news-graph-overview-vr-right');
    if (rightOverview) rightOverview.remove();

    const header = rightPanel.querySelector('.main-header');
    if (header) {
      header.setAttribute('visible', true);
      header.setAttribute('position', '0 0.005 0');
    }

    const rc = rightPanel.components['right-container-control'];
    if (rc && rc.topMenuButtons && rc.topMenuButtons[0]) {
      rc.topMenuButtons[0].click();
    }
    const centerPanel = document.getElementById("large-center-panel");
    if (centerPanel) {
      const msEl = document.querySelector('[main-settings]');
      if (msEl && msEl.components['main-settings']) {
        const ms = msEl.components['main-settings'];
        ms.switchBlockingElement(centerPanel, !ms.isRepositioning);
      }
    }
  }

  _removeModeListener();
  _vrNewsGraphMode = '3d';
}

export function openNewsGraph() {
  if (window.VRPanelsSlidingManager) {
    window.VRPanelsSlidingManager.setSelectedEl(null);
  }
  document.body.classList.add('news-graph-active');
  const chartTypeEl = document.querySelector('[chart-type-control]');
  if (chartTypeEl && chartTypeEl.components['chart-type-control']) {
    chartTypeEl.components['chart-type-control'].clearSelection();
  }

  const centerPanel = document.getElementById("large-center-panel");
  if (!centerPanel) return;

  const currentPos = centerPanel.getAttribute('position') || { x: 0, y: 1.6, z: -1.2 };
  const isAtCenter = Math.abs(currentPos.x) < 0.4 && Math.abs(currentPos.z + 1.2) < 0.4;
  if (!isAtCenter) {
    centerPanel.setAttribute('position', '0 1.6 -1.2');
    centerPanel.setAttribute('rotation', '0 0 0');
    centerPanel.setAttribute('expected-panel-rotation', '0 0 0');
  }

  const carouselEl = document.querySelector('#carousel') || document.querySelector('[main-elements-moving]');
  if (carouselEl && carouselEl.components['main-elements-moving']) {
    carouselEl.components['main-elements-moving'].data.currentStep = 0;
  }

  if (window.VRPanelsSlidingManager && typeof window.VRPanelsSlidingManager.resetPanelOrigPositions === 'function') {
    window.VRPanelsSlidingManager.resetPanelOrigPositions();
  }

  const blockingPlane = centerPanel.querySelector('.blocking-plane');
  if (blockingPlane) {
    blockingPlane.setAttribute('visible', false);
    blockingPlane.removeAttribute('data-raycastable');
  }
  
  if (typeof window.animateDockVisibility === 'function') {
    window.animateDockVisibility(false);
  }
  
  const centerPanelContent = document.getElementById("large-center-panel-content") || centerPanel;

  const existingZeroPlane = document.querySelector('#zero-plane');
  if (existingZeroPlane) {
    existingZeroPlane.setAttribute('visible', false);
  }

  const stockCubeWrapper = document.getElementById('stock-3d-cube-wrapper');
  if (stockCubeWrapper) {
    stockCubeWrapper.remove();
  }

  let wrapper = document.getElementById(`news-graph-wrapper`);
  if (!wrapper) {
    wrapper = document.createElement("a-box");
    wrapper.setAttribute("id", `news-graph-wrapper`);
    wrapper.setAttribute("width", 0.75);
    wrapper.setAttribute("height", 0.75);
    wrapper.setAttribute("depth", 0.75);
    wrapper.setAttribute("material", `opacity: 0; transparent: true; side: back; depthTest: false`);
    wrapper.setAttribute("position", "-0.25 0.2 -0.25");
    wrapper.setAttribute("rotation", "30 45 0");
    wrapper.setAttribute("news-graph-rotation", "target: #news-graph-wrapper");
    wrapper.setAttribute("data-raycastable", "");
    wrapper.addEventListener('click', (evt) => {
      if (evt.target === wrapper) {
        const newsGraphEl = document.getElementById('news-graph');
        const comp = newsGraphEl && newsGraphEl.components[_getActiveComponentName()];
        if (comp && !comp._nodeClickedThisFrame) {
          comp.setSelectedNodeEl(null);
        }
      }
    });
    centerPanelContent.appendChild(wrapper);

    const newsGraphCube = document.createElement("a-entity");
    newsGraphCube.setAttribute("id", "news-graph");
    newsGraphCube.setAttribute(_getActiveComponentName(), "");
    wrapper.appendChild(newsGraphCube);
  }

  wrapper.setAttribute('visible', true);
  if (!wrapper.hasAttribute('data-raycastable')) {
    wrapper.setAttribute('data-raycastable', '');
  }

  if (_vrNewsGraphMode === '2d') {
    wrapper.setAttribute('rotation', '0 45 0');
    wrapper.removeAttribute('data-raycastable');
    wrapper.setAttribute('news-graph-rotation', 'is2D: true; target: #news-graph-wrapper');
  } else {
    wrapper.setAttribute('rotation', '30 45 0');
    wrapper.setAttribute('data-raycastable', '');
    wrapper.setAttribute('news-graph-rotation', 'is2D: false; target: #news-graph-wrapper');
  }

  if (typeof window.addBannerAndRotationControls === 'function') {
    window.addBannerAndRotationControls("News Graph", "0.0 45 0", "0 .58 0", "0.023", "0 0 0.02", "news-graph");
    _updateBannerTheme();
  }

  mountLegendPanel();
  mountOverviewPanel();
  mountSourcesPanel();
  mountSettingsPanel();

  const scene = document.querySelector('a-scene');
  if (scene) {
    scene.emit('news-filter-changed', { filter: 'news-graph' });
  }

  _attachModeListener();


  const leftPanel2 = document.querySelector('#left-panel-2');
  if (leftPanel2) {
    const s1 = leftPanel2.querySelector('#news-screen-1');
    const s2 = leftPanel2.querySelector('#news-screen-2');
    if (s1) {
      s1.setAttribute('visible', true);
      s1.setAttribute('position', '0 0 0.02');
    }
    if (s2) {
      s2.setAttribute('visible', false);
      s2.setAttribute('position', '0 6 0');
    }
  }

  const rightPanel = document.querySelector('#right-container');
  if (rightPanel) {
    const tabsToHide = rightPanel.querySelectorAll('.live-chart-tab, .performance-tab, .profile-tab, .financials-tab, .main-header');
    tabsToHide.forEach(t => {
      t.setAttribute('visible', false);
      if (t.classList.contains('live-chart-tab') || t.classList.contains('main-header')) {
        t.setAttribute('position', '0 6 0');
      } else {
        t.setAttribute('position', '0 6.16 0.025');
      }
    });
    
    const overviewTab = rightPanel.querySelector('.news-overview-tab');
    if (overviewTab) {
      overviewTab.setAttribute('visible', true);
      overviewTab.setAttribute('position', '0 0.04 0.02');
    }
  }
}

let _vrNewsGraphMode = '3d';
let _modeToggleListener = null;

function _getActiveComponentName() {
  return _vrNewsGraphMode === '2d' ? 'news-graph-2d-vr' : 'news-graph-vr';
}

function _updateBannerTheme(evt) {
  let isLight = false;
  if (evt && evt.detail && evt.detail.themeMode) {
    isLight = evt.detail.themeMode === 'Light';
  } else {
    isLight = document.body.classList.contains('light') || document.body.classList.contains('cb-light');
    if (!isLight && typeof getCacheItem === 'function') {
      const settings = getCacheItem('mainSettings');
      if (settings && settings.themeMode === 'Light') isLight = true;
    }
  }
  const labelColor = isLight ? '#111827' : '#FFFFFF';
  const outlineColor = isLight ? '#FFFFFF' : '#000000';

  const banner = document.getElementById('stock-banner');
  if (banner) {
    banner.setAttribute('color', labelColor);
    banner.setAttribute('outline-color', outlineColor);
  }

  const timeDate = document.getElementById('current-time-date');
  if (timeDate) {
    timeDate.setAttribute('color', labelColor);
    timeDate.setAttribute('outline-color', outlineColor);
  }
}

function _attachModeListener() {
  _removeModeListener();
  const scene = document.querySelector('a-scene');
  if (!scene) return;

  _modeToggleListener = (evt) => {
    const requestedMode = evt && evt.detail && evt.detail.mode ? evt.detail.mode : '3d';
    if (requestedMode === _vrNewsGraphMode) return;
    _switchVRNewsGraphMode(requestedMode);
  };

  scene.addEventListener('news-graph-toggle-view-mode', _modeToggleListener);
  scene.addEventListener('theme-changed', _updateBannerTheme);
  window.addEventListener('theme-changed', _updateBannerTheme);
}

function _removeModeListener() {
  const scene = document.querySelector('a-scene');
  if (scene && _modeToggleListener) {
    scene.removeEventListener('news-graph-toggle-view-mode', _modeToggleListener);
    scene.removeEventListener('theme-changed', _updateBannerTheme);
  }
  window.removeEventListener('theme-changed', _updateBannerTheme);
  _modeToggleListener = null;
}

function _switchVRNewsGraphMode(newMode) {
  const newsGraphEl = document.getElementById('news-graph');
  if (!newsGraphEl) return;

  const wrapper = document.getElementById('news-graph-wrapper');
  if (wrapper) {
    if (newMode === '2d') {
      wrapper.setAttribute('rotation', '0 45 0');
      wrapper.removeAttribute('data-raycastable');
      wrapper.setAttribute('news-graph-rotation', 'is2D: true; target: #news-graph-wrapper');
    } else {
      wrapper.setAttribute('rotation', '30 45 0');
      wrapper.setAttribute('data-raycastable', '');
      wrapper.setAttribute('news-graph-rotation', 'is2D: false; target: #news-graph-wrapper');
    }
  }

  const oldCompName = _getActiveComponentName();
  const oldComp = newsGraphEl.components[oldCompName];
  const graphData = oldComp && oldComp.graphData;

  if (oldComp) {
    if (typeof oldComp.setSelectedNodeEl === 'function') {
      oldComp.setSelectedNodeEl(null, null, false);
    }
    if (typeof oldComp.remove === 'function') {
      newsGraphEl.removeAttribute(oldCompName);
    }
  }

  if (window.VRPanelsSlidingManager) {
    window.VRPanelsSlidingManager.setSelectedEl(null);
  }

  _vrNewsGraphMode = newMode;
  const newCompName = _getActiveComponentName();

  newsGraphEl.setAttribute(newCompName, '');

  if (graphData) {
    setTimeout(() => {
      const newComp = newsGraphEl.components[newCompName];
      if (newComp && typeof newComp.mount === 'function') {
        newComp.mount(graphData);
      }
    }, 50);
  }

  const scene = document.querySelector('a-scene');
  if (scene) {
    scene.emit('news-graph-view-mode-changed', { mode: newMode });
  }
}

if (typeof window !== 'undefined') {
  window.VRNewsGraphController = {
    openNewsGraph,
    closeNewsGraph,
  };
}
